export const MAP_MODAL: string = "MAP_MODAL";
export const SEARCH_FILTERS_MODAL: string = "SEARCH_FILTERS_MODAL";
export const MENU_MODAL: string = "MENU_MODAL";
export const LIGHTBOX_MODAL: string = "LIGHTBOX_MODAL";
export const GEOLOCATION_MODAL: string = "GEOLOCATION_MODAL";
